import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "hpm_admin_token";

export const getAdminToken = () => {
    try {
        return sessionStorage.getItem(TOKEN_KEY) || "";
    } catch {
        return "";
    }
};
export const setAdminToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

const adminApi = axios.create({ baseURL: `${BASE}/api` });
adminApi.interceptors.request.use((cfg) => {
    const t = getAdminToken();
    if (t) cfg.headers["X-Admin-Token"] = t;
    return cfg;
});

export const adminLogin = (token) => adminApi.post("/admin/login", { token }).then((r) => r.data);
export const adminOverview = () => adminApi.get("/admin/overview").then((r) => r.data);
export const adminOutbox = (status = "queued_no_provider", limit = 50) =>
    adminApi.get("/admin/outbox", { params: { status, limit } }).then((r) => r.data);
export const adminFlushOutbox = () => adminApi.post("/admin/outbox/flush").then((r) => r.data);
export const adminRecentLeads = (limit = 25) =>
    adminApi.get("/admin/leads/recent", { params: { limit } }).then((r) => r.data);
export const adminTransactions = (limit = 50, status = null) =>
    adminApi.get("/admin/transactions", { params: { limit, ...(status ? { status } : {}) } }).then((r) => r.data);
export const adminFireNewsletter = (dry_run = false) =>
    adminApi.post("/newsletter/send", null, { params: { dry_run } }).then((r) => r.data);
export const adminFireFirmDigest = (dry_run = false) =>
    adminApi.post("/firms-digest/send", null, { params: { dry_run } }).then((r) => r.data);

// Distribution channels
export const adminDistributionStatus = () =>
    adminApi.get("/admin/distribution/status").then((r) => r.data);
export const adminDistributionPingAll = () =>
    adminApi.post("/admin/distribution/ping-all").then((r) => r.data);

// Visitor analytics
export const adminVisitors = () =>
    adminApi.get("/admin/visitors").then((r) => r.data);

// Firm outreach hunter (revenue acquisition)
export const adminOutreachGenerate = (payload) =>
    adminApi.post("/admin/outreach/generate", payload).then((r) => r.data);
export const adminOutreachPackets = (status = null, limit = 100) =>
    adminApi
        .get("/admin/outreach/packets", {
            params: { ...(status ? { status } : {}), limit },
        })
        .then((r) => r.data);
export const adminOutreachSend = (packetId) =>
    adminApi.post(`/admin/outreach/${packetId}/send`).then((r) => r.data);
export const adminOutreachMarkSentManual = (packetId) =>
    adminApi.post(`/admin/outreach/${packetId}/mark-sent-manual`).then((r) => r.data);
export const adminOutreachStats = () =>
    adminApi.get("/admin/outreach/stats").then((r) => r.data);
export const adminOutreachSendAllDrafts = () =>
    adminApi.post("/admin/outreach/send-all-drafts").then((r) => r.data);

// Stripe refund (one-click)
export const adminRefund = (payload) =>
    adminApi.post("/admin/refund", payload).then((r) => r.data);

// Auto-drip outreach scheduler
export const adminDripRun = (dry_run = false) =>
    adminApi.post("/admin/drip/run", null, { params: { dry_run } }).then((r) => r.data);
